import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import tokenRefreshMiddleware from './middleware/tokenRefreshMiddleware';
import trackingMiddleware from './middleware/trackingMiddleware';

export default function configureStore() {
  const finalCreateStore = compose(
    applyMiddleware(thunk, tokenRefreshMiddleware, trackingMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
  )(createStore);

  const store = finalCreateStore(rootReducer);
  return store;
}
